import React from "react";
import "./Footer.scss";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaClock, FaMapMarkerAlt, FaRegCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import denviaLogo from '../../assets/footer/DenviaLogonew.png';

const Footer = () => {
  const footerMenu = [
    { name: "Home", link: "/" },
    { name: "About Us", link: "/about" },
    { name: "Know Your Doctor", link: "/knowyourdoctor" },
    { name: "Services", link: "/services" },
    { name: "Gallery", link: "/gallery/clinic" },
    { name: "Contact Us", link: "/" },
  ];

  const footerContacts = [
    {
      title: "Phone Number",
      info2: "+91 8690955575",
      icon: <FaPhoneAlt />,
    },
    {
      title: "Working Days",
      info: "Monday to Saturday",
      icon: <FaRegCalendarAlt />,
    },
    {
      title: "Open Hours",
      info: "10:00 AM - 8:00 PM",
      icon: <FaClock />,
    },
    {
      title: "Office Address",
      info: "68, Jan Path, Sarti Nagar, Shyam Nagar, Jaipur, Rajasthan 302019",
      icon: <FaMapMarkerAlt />,
    },
  ];

  return (
    <footer className="common-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-5 mb-4">
            <div className="footer-logo">
              <Link className="navbar-brand" to="/">
                <img src={denviaLogo} className='company-logo' alt="Denvia Logo" />
              </Link>
            </div>
            <p className="footer-text">
              Denvia Dental Clinic is dedicated to transforming smiles through advanced dental care and modern technology.
            </p>

            <div className="social-logo">
              <p>Follow us on</p>
              <ul>
                <li>
                  <a href="https://www.facebook.com/share/1G113aKHLa/"  target="_blank" rel="noopener noreferrer">
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/dr-aditya-jain-0a17b336b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer">
                    <FaLinkedinIn />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/denviadentalclinic?igsh=MXdwY2t5azYzM3o3Yw==" target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-2 mb-4">
            <div className="footer-link">
              <p>Quick Links</p>
              <ul>
                {footerMenu.map((singleMenu, idx) => (
                  <li key={idx}>
                    <Link to={singleMenu.link}>{singleMenu.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-5">
            <div className="footer-contact">
              <p>Contact & Information</p>
              {footerContacts.map((fc, idx) => (
                <div className="contact-list" key={idx}>
                  {fc.icon && <div className="footer-icons">{fc.icon}</div>}
                  <div className="contact-text">
                    <p>{fc.title}</p>
                    {fc.info && <h5>{fc.info}</h5>}
                    {fc.info2 && <h5>{fc.info2}</h5>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="copyright-area">
          <div className="copy-text">
            <p>&copy; Denvia Dental clinic. All Right Reserved</p>
          </div>
          <div className="copy-links">
            <ul>
              <li>
                <Link to="/">Terms of Use</Link>
              </li>
              <li>
                <Link to="/">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
